import type { VoidFunctionComponent } from 'react';

import './NotificationDot.less';

type Props = {
  //  Diamater of the circle, in pixels.
  size?: number;
};

const STROKE_PERCENT = 16.6666666667;
const RADIUS_PERCENT = 100 - STROKE_PERCENT; // > 83.333333334

//  Stroke is roughly 16.666...% of the size
const getStrokeWidth = (size: number): number =>
  size * (STROKE_PERCENT / 100);

//  Radius is the size of the "inner" circle, ie: the size / 2
const getRadius = (size: number): number =>
  (size / 2) * (RADIUS_PERCENT / 100);

const getCoords = (size: number): { cx: number, cy: number } => ({
  cx: size / 2,
  cy: size / 2,
});

/**
 * NotificationDot is a small SVG circle which will
 * attempt to absolutely position itself at the top-right
 * of your relatively positioned parent element.
 */
const NotificationDot: VoidFunctionComponent<Props> = ({ size = 12 }) => (
  <svg className="fossa-notification-dot" width={size} height={size}>
    <circle
      r={getRadius(size)}
      strokeWidth={getStrokeWidth(size)}
      {...getCoords(size)}
    />
  </svg>
);

export default NotificationDot;
